module.exports = __webpack_public_path__ + "assets/img/weakness-potion.3365ae2d.png";